import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import moment from 'moment';

dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone)

export default dayjs;

const datePattern = 'YYYY-MM-DD HH:mm:ss';

const getTimezone = () => {
  const utcOffset = moment().utcOffset();
  const utcHour = Math.round(utcOffset / 60);
  const obj = {
    "-10": "Pacific/Honolulu",
    "-8": "America/Juneau",
    "-7": "America/Los_Angeles",
    "-6": "America/El_Salvador",
    "-5": "America/Chicago",
    "-4": "America/New_York",
    "-3": "America/Sao_Paulo",
    0: "Etc/UTC",
    1: "Africa/Lagos",
    2: "Africa/Cairo",
    3: "Asia/Jerusalem",
    4: "Asia/Dubai",
    "4:30": "Asia/Tehran",
    5: "Asia/Ashkhabad",
    "5:30": "Asia/Kolkata",
    "5:45": "Asia/Kathmandu",
    6: "Asia/Almaty",
    7: "Asia/Bangkok",
    8: "Asia/Hong_Kong",
    9: "Asia/Tokyo",
    "9:30": "Australia/Adelaide",
    10: "Australia/Brisbane",
    11: "Pacific/Norfolk",
    12: "Pacific/Auckland",
    13: "Pacific/Fakaofo",
  };

  const timezone = obj[utcHour + ""] || "Etc/UTC";
  console.log("timezone =", timezone);
  return timezone;
};

export const toUtc = (date, format = datePattern) => {
  if (date) {
    // 时间的转化和pc端保持一致
    // return dayjs.utc(date).format(format);
    // return dayjs.tz(dayjs(date).format(format), getTimezone()) ;
    return dayjs(date).tz(getTimezone()).format(format);
  }
  return '';
};

export const getRangeTime = (date, tail = '00:00:00') => (dayjs(dayjs(date).format(`YYYY-MM-DD ${tail}`)).valueOf());
export const getDateTime = (date) => (dayjs(date).valueOf());

// export const toUtc = (date, format = datePattern) => {
//   if (date) {
//     return dayjs.utc(date).format(format);
//   }
//   return '';
// };

export const utcToLocal = (date, format = datePattern) => {
  if (date) {
    return dayjs(date).format(format);
  }
  return '';
};